//for that chat id whosent last msg

const ChatHistory=[
    {name:"Agent",time:"11:22 am",msg:"Message from Agent ",img:"logo",id:"2"},
];
export default ChatHistory;